import { GET_GENDER_FOR_CHILD } from "../../../enums/Request/request.types";

export const getGenderForChildAction = (data) => {
    return {
        type: GET_GENDER_FOR_CHILD,
        payload: data,
    };
};
